import { gql } from '@apollo/client';

export default gql`
  fragment tag on tags {
    id
    label
    type
  }
`;
